import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { prop, assoc, propOr } from 'ramda';
import { Button, Input } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import { isNotNilOrEmpty } from 'ramda-adjunct';
import withUser from '../../../../withUser';
import { Section, Title } from '../../../../components';
import useActionGuard from '../../../../hooks/useActionGuard';
import UpdateRawDocumentMutation from '../../../../_graphql/mutations/documents/UpdateRawDocumentMutation';
import { customSuccessMessage, errorMessage } from '../../../../utils/messageMutation';
import UpdateCacheMutation from '../../../../_graphql/mutations/UpdateCacheMutation';

const useRawDocument = ({ rawDocumentId, rawDocument, offerId }) => {
  const [state, setState] = useState(rawDocument);
  const history = useHistory();
  const { loading, run } = useActionGuard();
  const isValid = isNotNilOrEmpty(prop('name', state));

  const onSave = () => {
    run(`save-raw-document-${rawDocumentId}`, (done) => {
      const callback = (successMessage) => (ok, error) => {
        if (ok && !error) {
          customSuccessMessage(successMessage);
          UpdateCacheMutation({ date: new Date(), key: `documents-${offerId}` }, () => {});
          history.push(`/offre/${offerId}/edition`);
        } else {
          errorMessage();
        }
        done(ok, error);
      };

      UpdateRawDocumentMutation({ rawDocumentId, filename: state.name }, callback('Le nom du document importé a bien été mis à jour.'));
    });
  };

  return {
    ...state,
    setState,
    onSave,
    isValid,
    loading: propOr(false, `save-raw-document-${rawDocumentId}`, loading)
  };
};

const RawDocumentForm = ({
  rawDocument,
  offerId,
  rawDocumentId
}) => {
  const {
    name,
    setState,
    onSave,
    isValid,
    loading
  } = useRawDocument({
    rawDocumentId, rawDocument, offerId
  });

  return (
    <>
      <Title
        title="Modifier le nom du document importé"
        backTo={`/offre/${offerId}/edition`}
      />
      <Section title="nom du document importé">
        <div className="flex gap-4">
          <Input
            value={name}
            placeholder="Nom du document importé"
            onChange={(e) => {
              setState(assoc('name', e.target.value));
            }}
            size="middle"
          />
        </div>
      </Section>
      <Button
        onClick={onSave}
        disabled={!isValid}
        loading={loading}
        className="block mx-auto mt-4"
        type="primary"
        size="large"
        icon={<ThunderboltOutlined />}
      >
        Mettre à jour le nom
      </Button>
    </>
  );
};

export default withUser(RawDocumentForm);
